import { FullFooter } from '@/components/Footer';
import SubscribeForm from '@/components/SubscribeForm';

const Pricing = ({ showToast, onSubscribe, onRequest }) => {
  return (
    <>
      <section className="page-hero" data-testid="pricing-hero">
        <h1>Good analysis. Free to read.</h1>
        <p>Start with the free weekly letter, or commission a research report on any project or company.</p>
      </section>

      <div className="pricing-grid" data-testid="pricing-grid">

        <div className="price-card" data-testid="price-card-free">
          <h3>Weekly Letter</h3>
          <p className="plan-desc">All published analysis. No credit card required.</p>
          <div className="price">$0<span>/mo</span></div>
          <div className="features">
            <div className="feat"><span className="check">&#10003;</span> Idea of the Week (every Tuesday)</div>
            <div className="feat"><span className="check">&#10003;</span> NC Weekly Letter</div>
            <div className="feat"><span className="check">&#10003;</span> Treasury Watch</div>
            <div className="feat"><span className="check">&#10003;</span> NC Private X Feed — coming soon</div>
          </div>
          <button onClick={onSubscribe} className="price-btn primary" style={{ marginTop: '24px' }} data-testid="free-subscribe-btn">Subscribe Free</button>
        </div>

        <div className="price-card" data-testid="price-card-research">
          <h3>Commission Report</h3>
          <p className="plan-desc">Deep-dive research on any crypto project or company.</p>
          <div className="price">Custom</div>
          <div className="features">
            <div className="feat"><span className="check">&#10003;</span> Choose a Project or Company</div>
            <div className="feat"><span className="check">&#10003;</span> Define your research requirements</div>
            <div className="feat"><span className="check">&#10003;</span> Set your own timeline and deadline</div>
            <div className="feat"><span className="check">&#10003;</span> Delivered as a structured report</div>
          </div>
          <button onClick={onRequest} className="price-btn primary" style={{ marginTop: '24px' }} data-testid="research-cta">Submit a Request</button>
        </div>

      </div>

      <section className="faq" data-testid="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-item" data-testid="faq-item-1">
          <h4>What is included in the Weekly Letter?</h4>
          <p>Everything we publish - the NC Weekly Letter (which includes the Idea of the Week and Treasury Watch), plus access to the NC Private X Feed. No paywalls, no credit card.</p>
        </div>
        <div className="faq-item" data-testid="faq-item-2">
          <h4>How does the Commission Report work?</h4>
          <p>Email us the project or company you want researched, your specific questions or requirements, and your preferred timeline. We will send a scope and price estimate before any work begins.</p>
        </div>
        <div className="faq-item" data-testid="faq-item-3">
          <h4>What types of research can I request?</h4>
          <p>Any crypto project, protocol, token, or company. This includes on-chain analysis, tokenomics deep-dives, competitive landscape, treasury strategy, and macro positioning.</p>
        </div>
        <div className="faq-item" data-testid="faq-item-4">
          <h4>How do I access the NC Private X Feed?</h4>
          <p>The NC Private X Feed is coming soon. Once live, subscribers will receive instructions via the welcome email to join the private list.</p>
        </div>
      </section>

      <section className="signup-section" data-testid="signup-section">
        <h2>Start with the free newsletter.</h2>
        <p>No credit card. No commitment. Just good analysis, every Tuesday.</p>
        <SubscribeForm showToast={showToast} dark className="cta-centered" />
      </section>

      <FullFooter onSubscribe={onSubscribe} />
    </>
  );
};

export default Pricing;
